export default {
  // 存储本地数据
  saveTodos(key, todos, times = 0, startTimes = 0) {
    const todosArr = todos;
    try {
      if (todosArr) {
        if (times) {
          todosArr.overTimes = times;
          if (startTimes !== 0) {
            todosArr.startTimes = startTimes;
          } else {
            todosArr.startTimes = Date.parse(new Date());
          }
        }
        // 执行存储
        window.localStorage.setItem(key, JSON.stringify(todosArr));
      } else {
        // 执行删除
        window.localStorage.removeItem(key);
      }
      return true;
    } catch (e) {
      console.log(e, '===============');
      return false;
    }
  },
  // 获取本地数据
  readTodos(key) {
    try {
      let item = window.localStorage.getItem(key);
      item = item !== null ? item : '{}';
      return JSON.parse(item || '[]');
    } catch (e) {
      return JSON.parse('[]');
    }
  },
  // 距离时间
  colorInterview(times) {
    // 获取当前时间戳
    const shijainchuo = Date.parse(new Date()) / 1000;
    let style;
    // 24小时内
    if (shijainchuo <= times && (shijainchuo + 86400) >= times) {
      style = 1;
    } else if (shijainchuo <= times && (shijainchuo + (86400 * 3)) >= times) {
      // 3天内
      style = 2;
    } else if ((shijainchuo + (86400 * 3)) <= times) {
      // 等待中
      style = 3;
    } else {
      // 等待中
      style = 4;
    }
    return style;
  },
  wenhouStr() {
    // 获取当前时间
    const timeNow = new Date();
    // 获取当前小时
    const hours = timeNow.getHours();
    // 设置默认文字
    let text = '';
    // 判断当前时间段
    if (hours >= 0 && hours <= 11) {
      text = '早上好';
    } else if (hours > 11 && hours <= 13) {
      text = '中午好';
    } else if (hours > 13 && hours <= 18) {
      text = '下午好';
    } else if (hours > 18 && hours <= 24) {
      text = '晚上好';
    }
    // 返回当前时间段对应的状态
    return text;
  },
  whereArrStr(arr) {
    if (arr) {
      if (arr instanceof Array) {
        console.log(arr, '==============');
        const strArr = [];
        arr.forEach((app) => {
          strArr.push(app.id);
        });
        return strArr.join();
      }
      return arr.id;
    }
    return '';
  },
};



// WEBPACK FOOTER //
// ./src/util/commons.js